import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { RestrictionNameDispatcher } from "./Variables";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";

export interface RestrictionReasonStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class RestrictionReasonStoreStatic extends BaseStore<RestrictionReasonStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(RestrictionNameDispatcher, (actionData) =>
            this.onRestrictionReasonStoreResponse(actionData)
        );
    }

    public getLastResult(): RestrictionReasonStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): RestrictionReasonStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onRestrictionReasonStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
